import React from "react";
import Cookies from "universal-cookie";
import dayjs from "dayjs";
import { CSVLink } from "react-csv";

import withAuth from "../../hoc/withAuth";
import MainLayout from "../../components/layouts/MainLayout";

import { otodisService } from "../../services/OtodisService";

import { Form, DatePicker, Input, Table, Button, Modal, Row, Col, Space, Tooltip, Select, Switch } from "antd";
import { SearchOutlined, ExportOutlined, CopyOutlined } from "@ant-design/icons";

import SelectDealer from "../../components/selects/SelectDealer";
import SelectStatusNotice from "../../components/selects/SelectStatusNotice";
import ModalDetailBBN from "../../components/modal/ModalDetailBBN";
import ModalPaymentProgressive from "../../components/modal/ModalPaymentProgressive";

class MonitoringOrder extends React.Component {
  token = new Cookies().get("_bbn_tn");
  tableColumn = [
    {
      title: "Kode Order",
      dataIndex: "order_code",
      key: "order_code",
      width: 220,
      ellipsis: true,
      render: (value, row) => {
        return (
          <React.Fragment>
            <span className={`font-90-link`} onClick={(event) => this.showDetail(row)}>
              {value}
              &nbsp;
              <Tooltip title="Click untuk copy kode order" color={"cyan"}>
                <CopyOutlined className={"small-avatar-link"} onClick={(event) => this.copyToClipboard(value)} />
              </Tooltip>
            </span>
          </React.Fragment>
        );
      },
    },
    {
      title: "Nama Konsumen",
      dataIndex: "customer_doc_name",
      key: "customer_doc_name",
      width: 120,
    },
    {
      title: "Tgl Penugasan",
      dataIndex: "create_date",
      key: "create_date",
      width: 100,
    },
    {
      title: "Usia",
      dataIndex: "create_date",
      key: "usia_order",
      width: 80,
      ellipsis: true,
      render: (value) => {
        const usia = dayjs().diff(dayjs(value), "days");
        return `${usia} hari`;
      },
      sorter: (a, b) => {
        const usiaA = dayjs().diff(dayjs(a.create_date), "days");
        const usiaB = dayjs().diff(dayjs(b.create_date), "days");
        return usiaA - usiaB;
      },
    },
    {
      title: "No Mesin",
      dataIndex: "vehicle_engine_number",
      key: "vehicle_engine_number",
      width: 110,
      ellipsis: true,
      render: (value, row) => {
        return (
          <React.Fragment>
            <span>
              {value}
              &nbsp;
              <Tooltip title="Click untuk copy kode order" color={"cyan"}>
                <CopyOutlined className={"small-avatar-link"} onClick={(event) => this.copyToClipboard(value)} />
              </Tooltip>
            </span>
          </React.Fragment>
        );
      },
    },
    {
      title: "Variant Kendaraan",
      dataIndex: "vehicle_variant_name",
      key: "vehicle_variant_name",
      width: 120,
    },
    {
      title: "Notice Uploaded",
      dataIndex: "vehicle_notice_data",
      key: "notice_uploaded",
      width: 100,
      render: (value, row) => {
        const scanStatus = row.vehicle_notice_scan_status;
        let statusNoticeUploaded = "FALSE";
        if (value) {
          if (value.jumlah > 0) {
            statusNoticeUploaded = "TRUE";
          }
        } else {
          statusNoticeUploaded = "FALSE";
        }
        return (
          <React.Fragment>
            <div>{statusNoticeUploaded}</div>
            {scanStatus && <span style={{ fontSize: "0.80em", fontWeight: "bold" }}>SCAN&nbsp;:&nbsp;{scanStatus}</span>}
          </React.Fragment>
        );
      },
    },
    {
      title: "Notice Approved",
      dataIndex: "payment_approved",
      key: "payment_approved",
      width: 80,
    },
    {
      title: "Lunas PK",
      dataIndex: "flag_has_outstanding",
      key: "flag_has_outstanding",
      width: 80,
      ellipsis: true,
    },
    {
      title: "Kepemilikan",
      dataIndex: "vehicle_notice_data",
      key: "ownership_order",
      width: 100,
      ellipsis: true,
      render: (value) => {
        if (!value) return "";
        return Number(value.ownership_order) || 1;
      },
    },
    {
      title: "Biaya Progresif",
      dataIndex: "progressive_cost",
      key: "progressive_cost",
      width: 100,
      ellipsis: true,
      render: (value) => {
        const number = Number(value);
        return !isNaN(number) ? number.toLocaleString() : "0";
      },
    },
    {
      title: "Status Bayar Progresif",
      dataIndex: "bill_progressive_status",
      key: "bill_progressive_status",
      width: 100,
    },
    {
      title: "Tgl Pelunasan",
      dataIndex: "bill_progressive_detail",
      key: "bill_progressive_detail",
      width: 80,
      render: (value) => {
        if (!value.qris_created_time) return "";
        return dayjs(value.qris_paid_time).format("YYYY-MM-DD HH:mm") || dayjs(value.qris_created_time).format("YYYY-MM-DD HH:mm") || "";
      },
    },
    {
      title: "Invoice Notice",
      dataIndex: "invoice_number",
      key: "invoice_number",
      width: 120,
    },
    {
      title: "Biaya Notice",
      dataIndex: "notice_cost",
      key: "notice_cost",
      width: 80,
      ellipsis: true,
      render: (value) => {
        const number = Number(value);
        return !isNaN(number) ? number.toLocaleString() : "0";
      },
    },
    {
      title: "Status Bayar Notice",
      dataIndex: "bill_notice_status",
      key: "bill_notice_status",
      width: 100,
    },
    {
      title: "Notice Ditetapkan",
      dataIndex: "vehicle_notice_data",
      key: "notice_ditetapkan",
      width: 100,
      render: (value) => {
        if (!value || !value.issued_date) return "";
        const d = dayjs(value.issued_date);
        return d.isValid() ? d.format("YYYY-MM-DD") : "";
      },
    },
    {
      title: "Tgl Upload Notice",
      dataIndex: "vehicle_notice_entry_date",
      key: "vehicle_notice_entry_date",
      width: 80,
    },
    {
      title: "Lama Proses Notice",
      dataIndex: "kpi_biro",
      key: "kpi_biro",
      width: 80,
      render: (value) => {
        if (value === null || value === undefined || value === "") return "";
        if (value === "-") return value;
        return `${value} Hari`;
      },
      sorter: (a, b) => (a.kpi_biro ?? -Infinity) - (b.kpi_biro ?? -Infinity),
    },
    {
      title: "Tgl Generate Notice",
      dataIndex: "bill_notice_generated_date",
      key: "bill_notice_generated_date",
      width: 80,
    },
    {
      title: "Biaya Proses",
      dataIndex: "process_cost",
      key: "process_cost",
      width: 80,
      ellipsis: true,
      render: (value) => {
        const number = Number(value);
        return !isNaN(number) ? number.toLocaleString() : "0";
      },
    },
    {
      title: "Status Bayar Proses",
      dataIndex: "bill_process_cost_status",
      key: "bill_process_cost_status",
      width: 100,
    },
    {
      title: "Invoice Bayar Proses",
      dataIndex: "bill_process_cost_invoice_number",
      key: "bill_process_cost_invoice_number",
      width: 120,
    },
    {
      title: "Tgl Penagihan",
      dataIndex: "bill_process_cost_submitted_date",
      key: "bill_process_cost_submitted_date",
      width: 80,
    },
    {
      title: "Tgl Pelunasan",
      dataIndex: "bill_process_cost_paid_date",
      key: "bill_process_cost_paid_date",
      width: 80,
    },
    {
      title: "Biaya PKB",
      dataIndex: "pkb_cost",
      key: "pkb_cost",
      width: 80,
      ellipsis: true,
      render: (value) => {
        const number = Number(value);
        return !isNaN(number) ? number.toLocaleString() : "0";
      },
    },
    {
      title: "Status Bayar PKB",
      dataIndex: "bill_pkb_status",
      key: "bill_pkb_status",
      width: 100,
    },
    {
      title: "Invoice Bayar PKB",
      dataIndex: "bill_pkb_invoice_number",
      key: "bill_pkb_invoice_number",
      width: 120,
    },
    {
      title: "Tgl Penagihan",
      dataIndex: "bill_pkb_submitted_date",
      key: "bill_pkb_submitted_date",
      width: 80,
    },
    {
      title: "Tgl Pelunasan",
      dataIndex: "bill_pkb_paid_date",
      key: "bill_pkb_paid_date",
      width: 80,
    },
    {
      title: "Biaya Jasa",
      dataIndex: "service_cost",
      key: "service_cost",
      width: 80,
      ellipsis: true,
      render: (value) => {
        const number = Number(value);
        return !isNaN(number) ? number.toLocaleString() : "0";
      },
    },
    {
      title: "Status Bayar Jasa",
      dataIndex: "bill_service_cost_status",
      key: "bill_service_cost_status",
      width: 100,
    },
    {
      title: "Invoice Bayar Jasa",
      dataIndex: "bill_service_cost_invoice_number",
      key: "bill_service_cost_invoice_number",
      width: 120,
    },
    {
      title: "Tgl Penagihan",
      dataIndex: "bill_service_cost_submitted_date",
      key: "bill_service_cost_submitted_date",
      width: 80,
    },
    {
      title: "Tgl Pelunasan",
      dataIndex: "bill_service_cost_paid_date",
      key: "bill_service_cost_paid_date",
      width: 80,
    },
    {
      title: "Status BBN",
      dataIndex: "transfer_title_status",
      key: "transfer_title_status",
      width: 90,
    },
    {
      title: "ID DDMS ",
      dataIndex: "daya_id_order",
      key: "daya_id_order",
      width: 120,
    },
    {
      title: "Tgl BAST DDMS",
      dataIndex: "daya_bast_date",
      key: "daya_bast_date",
      width: 100,
    },
    {
      title: "No Faktur DDMS",
      dataIndex: "daya_invoice_stnk",
      key: "daya_invoice_stnk",
      width: 110,
    },
    {
      title: "No Polisi",
      dataIndex: "vehicle_license_plate",
      key: "vehicle_license_plate",
      width: 100,
    },
    {
      title: "No STNK",
      dataIndex: "vehicle_registration_certificate_number",
      key: "vehicle_registration_certificate_number",
      width: 100,
    },
    {
      title: "Tgl STNK",
      dataIndex: "vehicle_registration_certificate_entry_date",
      key: "vehicle_registration_certificate_entry_date",
      width: 120,
      render: (value, row) => {
        return (
          <React.Fragment>
            <span>
              <b>IN</b>&nbsp;:&nbsp;{`${row.vehicle_registration_certificate_entry_date?.slice(0, -5)}`}
            </span>
            <br />
            <span>
              <b>OUT</b>&nbsp;:&nbsp;{`${row.vehicle_registration_certificate_submission_date?.slice(0, -5)}`}
            </span>
          </React.Fragment>
        );
      },
    },
    {
      title: "No BPKB",
      dataIndex: "vehicle_certificate_of_ownership_number",
      key: "vehicle_certificate_of_ownership_number",
      width: 100,
    },
    {
      title: "BPKB Status",
      dataIndex: "bpkb_status",
      key: "bpkb_status",
      width: 120,
    },
    {
      title: "Tgl BPKB",
      dataIndex: "vehicle_certificate_of_ownership_entry_date",
      key: "vehicle_certificate_of_ownership_entry_date",
      width: 120,
      render: (value, row) => {
        return (
          <React.Fragment>
            <span>
              <b>IN</b> : {`${row.vehicle_certificate_of_ownership_entry_date?.slice(0, -5)}`}
            </span>
            <br />
            <span>
              <b>OUT</b>: {`${row.vehicle_certificate_of_ownership_submission_date?.slice(0, -5)}`}
            </span>
          </React.Fragment>
        );
      },
    },
  ];

  generateFileCsv = React.createRef();
  constructor(props) {
    super(props);

    const { match } = this.props;
    const code_svb = match.params.code_svb;

    this.initState = {
      code_svb: code_svb,
      processing: false,
      processingFetchTableData: false,
      pageSize: 100,

      dataOrder: [],
      filterType: "ENGINE_NUMBER",
      filterEngineNumber: "",
      filterStatusBbn: "",
      filterDealer: "",
      filterDate: "",
      filterNoticeUpload: "ALL",
      filterBillType: "",
      filterBillStatus: "",
      filterBillInvoice: "",

      filterLocalNoticeScan: "ALL",
      filterLocalBillNoticeStatus: "ALL",
      filterLocalBillProcessCostStatus: "ALL",
      filterLocalBpkbStatus: "ALL",

      loadingButton: false,
      tableSelectedRowKeys: [],
      dataExport: [],
      rowDetailOrder: [],
      showModalDetailOrder: false,
      showModalPaymentProgressive: false,

      showProgresif: false,
      showNotice: true,
      showProses: true,
      showPkb: false,
      showJasa: false,
    };

    this.state = { ...this.initState };

    this.columnGroups = {
      notice: ["notice_cost", "bill_notice_status", "bill_notice_generated_date", "notice_ditetapkan", "kpi_biro"],
      proses: ["process_cost", "bill_process_cost_status", "bill_process_cost_invoice_number", "bill_process_cost_submitted_date", "bill_process_cost_paid_date"],
      progresif: ["progressive_cost", "bill_progressive_status", "bill_progressive_detail"],
      pkb: ["pkb_cost", "bill_pkb_status", "bill_pkb_invoice_number", "bill_pkb_submitted_date", "bill_pkb_paid_date"],
      jasa: ["service_cost", "bill_service_cost_status", "bill_service_cost_invoice_number", "bill_service_cost_submitted_date", "bill_service_cost_paid_date"],
    };
  }

  handleToggleColumn = (category) => {
    this.setState((prevState) => ({
      [`show${category.charAt(0).toUpperCase() + category.slice(1)}`]: !prevState[`show${category.charAt(0).toUpperCase() + category.slice(1)}`],
    }));
  };

  tableGetVissibleColoumns = () => {
    const activeKeys = [];

    if (this.state.showNotice) activeKeys.push(...this.columnGroups.notice);
    if (this.state.showProses) activeKeys.push(...this.columnGroups.proses);
    if (this.state.showProgresif) activeKeys.push(...this.columnGroups.progresif);
    if (this.state.showPkb) activeKeys.push(...this.columnGroups.pkb);
    if (this.state.showJasa) activeKeys.push(...this.columnGroups.jasa);

    return this.tableColumn.filter((col) => {
      // tampilkan semua kolom kecuali yang termasuk kategori dan sedang di-hide
      return !Object.values(this.columnGroups).some((group) => group.includes(col.key)) || activeKeys.includes(col.key);
    });
  };

  tableGetVisibleColumnsWidth = () => {
    const visibleColumns = this.tableGetVissibleColoumns();
    return visibleColumns.reduce((total, col) => {
      return total + (col.width || 120); // fallback default width
    }, 0);
  };

  copyToClipboard = async (data) => {
    await navigator.clipboard.writeText(data);
  };

  handleFieldChange = (field, value) => {
    this.setState({ [field]: value });

    if (field === "filterType") {
      this.setState({ filterEngineNumber: "" });
    }
  };

  changeFilterDate = (date, dateString) => {
    this.setState({
      filterDate: dateString,
    });
  };

  closeModalDetailOrder = (data) => {
    this.setState({
      showModalDetailOrder: false,
    });
  };

  showDetail = (data) => {
    // console.log(data);
    this.setState({
      rowDetailOrder: data,
      showModalDetailOrder: true,
    });
  };

  closeModalPaymentProgressive = () => {
    this.setState({
      showModalPaymentProgressive: false,
    });
  };

  showModalProgressive = (data) => {
    // console.log(data);
    this.setState({
      rowDetailOrder: data,
      showModalPaymentProgressive: true,
    });
  };

  handleResetLocalFilter = () => {
    this.setState({
      filterLocalNoticeScan: "ALL",
      filterLocalBillNoticeStatus: "ALL",
      filterLocalBillProcessCostStatus: "ALL",
      filterLocalBpkbStatus: "ALL",
    });
  };

  getDataOrderFiltered = () => {
    const { dataOrder, filterLocalNoticeScan, filterLocalBillNoticeStatus, filterLocalBillProcessCostStatus, filterLocalBpkbStatus } = this.state;
    return (dataOrder || []).filter((item) => {
      if (filterLocalNoticeScan && filterLocalNoticeScan !== "ALL") {
        const val = (item.vehicle_notice_scan_status || "").toUpperCase();
        if (val !== filterLocalNoticeScan.toUpperCase()) return false;
      }
      if (filterLocalBillNoticeStatus && filterLocalBillNoticeStatus !== "ALL") {
        const val = (item.bill_notice_status || "").toUpperCase();
        if (val !== filterLocalBillNoticeStatus.toUpperCase()) return false;
      }
      if (filterLocalBillProcessCostStatus && filterLocalBillProcessCostStatus !== "ALL") {
        const val = (item.bill_process_cost_status || "").toUpperCase();
        if (val !== filterLocalBillProcessCostStatus.toUpperCase()) return false;
      }
      if (filterLocalBpkbStatus && filterLocalBpkbStatus !== "ALL") {
        const val = (item.bpkb_status || "").toUpperCase();
        if (filterLocalBpkbStatus === "NOT UPLOADED") {
          if (val !== "NOT UPLOADED" && val !== "") return false;
        } else {
          if (val !== filterLocalBpkbStatus.toUpperCase()) return false;
        }
      }
      return true;
    });
  };

  onChangeTable = (pagination, filters, sorter, extra) => {
    // Antd Table internal filter handler
  };

  fetchDataOrder = async () => {
    try {
      const filter = this.state;

      if (!filter.filterEngineNumber) {
        if (!filter.filterStatusBbn) {
          throw new Error("Status is Required");
        } else {
          if (!filter.filterDate && !filter.filterEngineNumber && filter.filterStatusBbn === "GENERATED") {
            throw new Error("Date is Required");
          }
        }
      }

      this.setState({
        processingFetchTableData: true,
        loadingButton: true,
      });

      const params = {};

      params.service_bureau_code = this.state.code_svb;
      if (filter.filterEngineNumber !== "") {
        params.vehicle_engine_number = filter.filterEngineNumber;
      } else {
        if (filter.filterStatusBbn !== "") {
          params.transfer_title_status = filter.filterStatusBbn;
        }
        if (filter.filterDealer !== "") {
          params.dealer_code = filter.filterDealer;
        }

        if (filter.filterDate !== "") {
          params.date_start = dayjs(filter.filterDate).clone().startOf("month").format("YYYY-MM-DD");
          params.date_end = dayjs(filter.filterDate).clone().endOf("month").format("YYYY-MM-DD");
        }

        if (filter.filterNoticeUpload !== "ALL") {
          params.notice_uploaded = filter.filterNoticeUpload === "TRUE" ? true : false;
        }

        if (filter.filterStatusBbnBayar !== "ALL") {
          switch (filter.filterStatusBbnBayar) {
            case "LUNAS_NOTICE":
              params.paid_notice_cost = true;
              break;

            case "LUNAS_PROSES":
              params.paid_process_cost = true;
              break;

            case "BELUM_LUNAS_NOTICE":
              params.paid_notice_cost = false;
              break;

            case "BELUM_LUNAS_PROSES":
              params.paid_process_cost = false;
              break;

            default:
              break;
          }
        }
      }

      // console.log("params", params);
      otodisService.setToken(this.token);
      const dataOrder = await otodisService.getAssignedOrder(params);
      // console.log(dataOrder.data.success.data);

      this.setState({
        dataOrder: dataOrder.data.success.data,
        processingFetchTableData: false,
        loadingButton: false,
        tableSelectedRowKeys: [],
      });
    } catch (error) {
      this.setState({
        dataOrder: [],
        processingFetchTableData: false,
        loadingButton: false,
        tableSelectedRowKeys: [],
      });
      Modal.error({
        title: "Validation Error",
        content: error.message,
      });
      return false;
    }
  };

  onClickFilter = async () => {
    await this.fetchDataOrder();
  };

  onClickExport = async () => {
    const selectedRows = this.state.tableSelectedRowKeys;
    if (!selectedRows || selectedRows.length === 0) {
      Modal.error({
        title: "Validation Error",
        content: "Tidak Ada Data yang Dipilih",
      });
      return;
    }

    const headers = this.tableColumn.map((col) => col.title);
    const rows = [];

    selectedRows.forEach((row) => {
      const rowData = this.tableColumn.map((col) => {
        const dataIndex = col.dataIndex;
        const render = col.render;
        let value;

        if (dataIndex === "order_code") {
          value = row.order_code;
        } else if (dataIndex === "vehicle_engine_number") {
          value = row.vehicle_engine_number;
        } else if (dataIndex === "vehicle_registration_certificate_entry_date") {
          value = `IN: ${row.vehicle_registration_certificate_entry_date?.slice(0, -5) || ""} - OUT: ${row.vehicle_registration_certificate_submission_date?.slice(0, -5) || ""}`;
        } else if (dataIndex === "vehicle_certificate_of_ownership_entry_date") {
          value = `IN: ${row.vehicle_certificate_of_ownership_entry_date?.slice(0, -5) || ""} - OUT: ${row.vehicle_certificate_of_ownership_submission_date?.slice(0, -5) || ""}`;
        } else {
          value = dataIndex
            ? dataIndex
              .toString()
              .split(".")
              .reduce((acc, curr) => (acc ? acc[curr] : undefined), row)
            : undefined;

          if (render && typeof render === "function") {
            try {
              value = render(value, row);
              if (typeof value === "object" && value !== null && !Array.isArray(value)) {
                value = "";
              }
            } catch (err) {
              value = "";
            }
          }
        }

        return value ?? "";
      });

      rows.push(rowData);
    });

    console.log("headers", headers);
    console.log("rows", rows);

    const dataParsed = [headers, ...rows];

    this.setState({ loadingButton: true });

    try {
      await this.setState({
        dataExport: dataParsed,
      });

      this.generateFileCsv.current.link.click();

      this.setState({
        loadingButton: false,
      });
    } catch (error) {
      Modal.error({
        title: "Process Error",
        content: error.message,
      });
    }
  };

  handlePaymentUpdate = (updateRow) => {
    const updateListOrder = this.state.dataOrder.map((item) => {
      if (item.order_code === updateRow.order_code) {
        // console.log("NEW", item.order_code, item.progressive_payment_status, item.progressive_payment_detail);
        return {
          ...item,
          ...updateRow,
        };
      }
      return item;
    });

    this.setState({
      rowDetailOrder: updateRow,
      dataOrder: updateListOrder,
    });
  };

  renderToggleSwitch = (key, label, stateKey) => {
    return (
      <div>
        <Switch className="custom-switch" checked={this.state[stateKey]} onChange={() => this.handleToggleColumn(key)} checkedChildren={`Tampil ${label}`} unCheckedChildren={`Tidak Tampil ${label}`} />
      </div>
    );
  };

  render() {
    const rowTableSelection = {
      onChange: (selectedRowKeys, selectedRows) => {
        this.setState({
          tableSelectedRowKeys: selectedRows,
        });
      },
    };
    return (
      <React.Fragment>
        <MainLayout defaultOpenKeys={["2monitoringdata"]} defaultSelectedKeys={["3monitoringorder"]}>
          <div style={{ padding: 10, margin: 10, background: "#FFF" }}>
            <strong style={{ float: "right" }}>Monitoring Order</strong>
            <Form name="form-filter" layout="vertical" style={{ padding: 8 }}>
              <Row>
                <Col style={{ paddingLeft: 2, paddingRight: 2, minWidth: 150 }}>
                  <Form.Item label="Cari Menggunakan">
                    <Select value={this.state.filterType} onChange={(value) => this.handleFieldChange("filterType", value)} placeholder="Select Type Filter">
                      <Select.Option key="ENGINE_NUMBER">Nomor Mesin</Select.Option>
                      <Select.Option key="CUSTOM_FILTER">Custom Filter</Select.Option>
                    </Select>
                  </Form.Item>
                </Col>
                {this.state.filterType === "ENGINE_NUMBER" && (
                  <Col style={{ paddingLeft: 2, paddingRight: 2, minWidth: 150 }}>
                    <Form.Item label="Nomor Mesin">
                      <Input value={this.state.filterEngineNumber} onChange={(event) => this.handleFieldChange("filterEngineNumber", event.target.value)} />
                    </Form.Item>
                  </Col>
                )}
                {this.state.filterType === "CUSTOM_FILTER" && (
                  <React.Fragment>
                    <Col style={{ paddingLeft: 2, paddingRight: 2, minWidth: 150 }}>
                      <Form.Item label="Status BBN">
                        <Select value={this.state.filterStatusBbn} onChange={(value) => this.handleFieldChange("filterStatusBbn", value)} placeholder="Pilih Status">
                          <Select.Option key="INPUTED" value="INPUTED">
                            INPUTED
                          </Select.Option>
                          <Select.Option key="UPLOADED" value="UPLOADED">
                            BELUM LUNAS
                          </Select.Option>
                          <Select.Option key="PAID" value="GENERATED">
                            SUDAH LUNAS
                          </Select.Option>
                        </Select>
                      </Form.Item>
                    </Col>

                    <Col style={{ paddingLeft: 2, paddingRight: 2, minWidth: 300 }}>
                      <SelectDealer value={this.state.filterDealer} onChangeValue={(value) => this.handleFieldChange("filterDealer", value)} />
                    </Col>

                    <Col style={{ paddingLeft: 2, paddingRight: 2, minWidth: 150 }}>
                      <Form.Item label="Tanggal Order">
                        <DatePicker onChange={this.changeFilterDate} picker="month" />
                      </Form.Item>
                    </Col>

                    <Col style={{ paddingLeft: 2, paddingRight: 2, minWidth: 150 }}>
                      <SelectStatusNotice value={this.state.filterNoticeUpload} onChangeValue={(value) => this.handleFieldChange("filterNoticeUpload", value)} />
                    </Col>
                  </React.Fragment>
                )}
                <Col style={{ paddingLeft: 2, paddingRight: 2 }}>
                  <Form.Item label="&nbsp;">
                    <Space.Compact style={{ width: "100%" }}>
                      <Button onClick={this.onClickFilter} type="primary" icon={<SearchOutlined />} title="filter" style={{ minWidth: "50%", background: "#1784b8", borderColor: "#1784b8" }} loading={this.state.loadingButton}>
                        Filter
                      </Button>
                      &nbsp;
                      <Button onClick={this.onClickExport} type="primary" icon={<ExportOutlined />} title="export excel" style={{ minWidth: "50%", background: "#17a2b8", borderColor: "#17a2b8" }} loading={this.state.loadingButton}>
                        Export
                      </Button>
                    </Space.Compact>
                  </Form.Item>
                </Col>
              </Row>
              <div style={{ marginBottom: 12, padding: "10px 12px", background: "#f9fafb", border: "1px solid #e5e7eb", borderRadius: 3 }}>

                <Row gutter={[8, 8]} align="bottom">
                  <Col style={{ minWidth: 160 }}>
                    <Form.Item label="Notice Scan" style={{ marginBottom: 0 }}>
                      <Select
                        value={this.state.filterLocalNoticeScan}
                        onChange={(value) => this.handleFieldChange("filterLocalNoticeScan", value)}
                        placeholder="Notice Scan"
                        style={{ width: "100%" }}
                      >
                        <Select.Option value="ALL">ALL</Select.Option>
                        <Select.Option value="COMPLETED">COMPLETED</Select.Option>
                        <Select.Option value="PENDING">PENDING</Select.Option>
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col style={{ minWidth: 180 }}>
                    <Form.Item label="Status Bayar Notice" style={{ marginBottom: 0 }}>
                      <Select
                        value={this.state.filterLocalBillNoticeStatus}
                        onChange={(value) => this.handleFieldChange("filterLocalBillNoticeStatus", value)}
                        placeholder="Status Bayar Notice"
                        style={{ width: "100%" }}
                      >
                        <Select.Option value="ALL">ALL</Select.Option>
                        <Select.Option value="PENDING">PENDING</Select.Option>
                        <Select.Option value="GENERATED">GENERATED</Select.Option>
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col style={{ minWidth: 180 }}>
                    <Form.Item label="Status Bayar Proses" style={{ marginBottom: 0 }}>
                      <Select
                        value={this.state.filterLocalBillProcessCostStatus}
                        onChange={(value) => this.handleFieldChange("filterLocalBillProcessCostStatus", value)}
                        placeholder="Status Bayar Proses"
                        style={{ width: "100%" }}
                      >
                        <Select.Option value="ALL">ALL</Select.Option>
                        <Select.Option value="PENDING">PENDING</Select.Option>
                        <Select.Option value="REQUESTED">REQUESTED</Select.Option>
                        <Select.Option value="PAYMENT-ATTEMPT">PAYMENT-ATTEMPT</Select.Option>
                        <Select.Option value="PAID">PAID</Select.Option>
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col style={{ minWidth: 180 }}>
                    <Form.Item label="BPKB Status" style={{ marginBottom: 0 }}>
                      <Select
                        value={this.state.filterLocalBpkbStatus}
                        onChange={(value) => this.handleFieldChange("filterLocalBpkbStatus", value)}
                        placeholder="BPKB Status"
                        style={{ width: "100%" }}
                      >
                        <Select.Option value="ALL">ALL</Select.Option>
                        <Select.Option value="NOT UPLOADED">NOT UPLOADED</Select.Option>
                        <Select.Option value="UPLOADED">UPLOADED</Select.Option>
                        <Select.Option value="MATCHED">MATCHED</Select.Option>
                        <Select.Option value="NOT MATCHED">NOT MATCHED</Select.Option>
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col>
                    <Form.Item label=" " style={{ marginBottom: 0 }}>
                      <Button onClick={this.handleResetLocalFilter}>
                        Reset Filter
                      </Button>
                    </Form.Item>
                  </Col>
                </Row>
              </div>

              <Row>
                <Space>
                  {this.renderToggleSwitch("progresif", "Progresif", "showProgresif")}
                  {this.renderToggleSwitch("notice", "Notice", "showNotice")}
                  {this.renderToggleSwitch("proses", "Proses", "showProses")}
                  {this.renderToggleSwitch("pkb", "PKB", "showPkb")}
                  {this.renderToggleSwitch("jasa", "Jasa", "showJasa")}
                </Space>
              </Row>
            </Form>

            <CSVLink data={this.state.dataExport} filename="data-order.csv" ref={this.generateFileCsv} target="_blank" style={{ display: "none" }}>
              Export
            </CSVLink>

            <Table
              rowSelection={rowTableSelection}
              scroll={{ x: this.tableGetVisibleColumnsWidth() }}
              rowKey={"order_code"}
              size={"small"}
              loading={this.state.processingFetchTableData}
              columns={this.tableGetVissibleColoumns()}
              dataSource={this.getDataOrderFiltered()}
              pagination={{ pageSize: this.state.pageSize }}
              onChange={this.onChangeTable}
              className="text-uppercase"
              style={{ fontSize: "10%" }}
            />
          </div>
          <ModalDetailBBN kodeOrder={"aaaa"} dataOrder={this.state.rowDetailOrder} visible={this.state.showModalDetailOrder} onClose={this.closeModalDetailOrder} />
          <ModalPaymentProgressive kodeOrder={"aaaa"} dataOrder={this.state.rowDetailOrder} visible={this.state.showModalPaymentProgressive} onClose={this.closeModalPaymentProgressive} onPaymentUpdate={this.handlePaymentUpdate} />
        </MainLayout>
      </React.Fragment>
    );
  }
}

export default withAuth(MonitoringOrder);
